module.exports = __webpack_public_path__ + "img/fzds1.d84792ce.png";